import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { payoutService } from '@/api/services/payoutService'

// The three list hooks only fire when params are supplied — passing `undefined`
// (the inactive tab) disables the query so we never hit an endpoint we're not
// showing (e.g. the unimplemented get-by-vendors 501).
export function useTrainerPayouts(p?: Parameters<typeof payoutService.trainerPayouts>[0]) {
  return useQuery({ queryKey: ['payouts', 'trainer', p], queryFn: () => payoutService.trainerPayouts(p), staleTime: 30_000, enabled: p !== undefined })
}

export function useSchoolPayouts(p?: Parameters<typeof payoutService.schoolPayouts>[0]) {
  return useQuery({ queryKey: ['payouts', 'school', p], queryFn: () => payoutService.schoolPayouts(p), staleTime: 30_000, enabled: p !== undefined })
}

export function useAssistantPayouts(p?: Parameters<typeof payoutService.assistantPayouts>[0]) {
  return useQuery({ queryKey: ['payouts', 'assistant', p], queryFn: () => payoutService.assistantPayouts(p), staleTime: 30_000, enabled: p !== undefined })
}

export function useAllPayouts(p?: Parameters<typeof payoutService.allPayouts>[0]) {
  return useQuery({ queryKey: ['payouts', 'all', p], queryFn: () => payoutService.allPayouts(p), staleTime: 30_000 })
}

export function usePayoutHistory(p?: Parameters<typeof payoutService.payHistory>[0]) {
  return useQuery({
    queryKey: ['payouts', 'history', p],
    queryFn: () => payoutService.payHistory(p),
    staleTime: 30_000,
    // transfer/get-list requires trainer_id — only fire once one is selected.
    enabled: !!(p as Record<string, unknown> | undefined)?.trainer_id,
  })
}

export function usePayToTrainer() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => payoutService.payToTrainer(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['payouts'] }),
  })
}

export function usePayToSchool() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => payoutService.payToSchool(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['payouts'] }),
  })
}

// Alias for backward compat
export const useApprovePayout = usePayToTrainer
